import { Link } from "react-router-dom";

/**
 * Wordmark. Renders as a router Link by default so it navigates to `to`.
 * Pass `asSpan` when the wordmark is nested inside another interactive
 * element (e.g. a parent-company lockup that already links out) — this
 * avoids the "`<a>` cannot be a descendant of `<a>`" hydration warning.
 */
export const BrontoWordmark = ({ size = "text-2xl", to = "/", className = "", asSpan = false }) => {
  const inner = (
    <>
      <span className="text-foreground">Bronto</span>
      <span className="rainbow-text">Y</span>
    </>
  );
  const shared = `font-display font-semibold ${size} tracking-tighter leading-none inline-flex items-baseline gap-0.5 ${className}`;
  if (asSpan) {
    return (
      <span data-testid="brontoy-wordmark" className={shared}>
        {inner}
      </span>
    );
  }
  return (
    <Link to={to} data-testid="brontoy-wordmark" className={shared}>
      {inner}
    </Link>
  );
};

export const YMark = ({ className = "" }) => (
  <span
    aria-hidden
    className={`inline-block rainbow-text font-display font-black leading-none ${className}`}
  >
    Y
  </span>
);
